import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Section from '../../Utilitis/Section'
import SingalHeader from '../../Utilitis/SingalHeader'
import Blog from "../../Utilitis/Blog/Blog"


export default function Blogs() {
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
        }
    }, []);
    return (
        < >
            <SingalHeader title="Our Blogs" />
            <Section bg="white" bg_Img={"/images/courses_background.jpg"}>
                <Container>
                    <Row>
                        <Col lg={4} md={6} sm={12} xs={12}><Blog title="Pro eu error molestie deserunt" image="/images/blog01.jpg" /></Col>
                        <Col lg={4} md={6} sm={12} xs={12}><Blog title="Student Award 2021" image="/images/blog04.jpg" /></Col>
                        <Col lg={4} md={6} sm={12} xs={12}><Blog title="Pro eu error molestie deserunt" image="/images/blog03.jpg" /></Col>
                        <Col lg={4} md={6} sm={12} xs={12}><Blog title="Pro eu error molestie deserunt" image="/images/blog04.jpg" /></Col>
                        <Col lg={4} md={6} sm={12} xs={12}><Blog title="Pro eu error molestie deserunt" image="/images/blog02.jpg" /></Col>
                        <Col lg={4} md={6} sm={12} xs={12}><Blog title="Pro eu error molestie deserunt" image="/images/blog01.jpg" /></Col>
                    </Row>
                </Container>
            </Section>
        </>
    )
}
